enum FootfallViewType {
  List,
  Map,
}

export default FootfallViewType;
